import jp from "jsonpath";

//OBTENGO LOS NAMES PADRES REALACIONES SIMPLE
const relatedParentsSimple = (formulario) => {
  const query =
    '$.form.questions[?(@.related)][?(@.relatedness === "simple" || @.relatedness === "multiple")].name';
  const related = jp.query(formulario, query);
  return [...new Set(related)].sort((a, b) => a > b);
};

//OBTENGO LOS OBJETOS QUE CONTINEN RELACION COMPUESTAS
const relatedParentsCompund = (formulario) => {
  const query =
    '$.form.questions[?(@.related && @.related.relatedness === "compound")]';
  const related = jp.query(formulario, query);
  return related;
};

//OBTENGO LOS OBJETOS QUE CONITNEN RELACIÓN LISTENER
const relatedParentsListener = (formulario) => {
  const query =
    '$.form.questions[?(@.related && @.related.relatedness === "listener")]';
  const related = jp.query(formulario, query);
  return related;
};

//CREA LA ESTRUCTURA PARA LAS RELACIONES SIMPLES
const createRelatedSimple = (arrayParents, formulario) => {
  let simple = {};
  for (const i of arrayParents) {
    const query = `$.form.questions[?(@.related && @.related.name === "${i}")]`;
    const result = jp.query(formulario, query);

    for (const j of result) {
      simple[i];
      simple[i] = {
        ...simple[i],
        [j.name]: j.related,
      };
    }
  }
  return simple;
};

//CREA LA ESTRUCTURA PARA LAS RELACIONES COMPUESTAS
const createRelatedCompound = (arrayObjectCompound) => {
  let compound = {};

  for (const i of arrayObjectCompound) {
    compound[i.name] = i.related;
  }

  return compound;
};

//CREA LA ESTRUCTURA PARA LAS RELACIONES LISTENER
const createRelatedListener = (arrayObjectListener) => {
  let listener = {};

  for (const i of arrayObjectListener) {
    listener[i.name] = { related: i.related };
  }

  return listener;
};

//OBTIENE LAS PREGUNTAS HIJAS
const relatednessChildren = (formulario) => {
  const query = `$.form.questions[?(@.related)].name`;
  const result = jp.query(formulario, query);
  return result;
};

export {
  relatedParentsSimple,
  relatedParentsCompund,
  relatedParentsListener,
  createRelatedSimple,
  createRelatedCompound,
  createRelatedListener,
  relatednessChildren,
};
